// Legal constants used across Terms, Privacy, and other legal pages.
// TODO: replace COMPANY_NAME with the registered legal entity name once confirmed.
export const COMPANY_NAME = 'Kinora';
export const JURISDICTION = 'Alberta, Canada';
export const EFFECTIVE_DATE = 'July 4, 2026';
export const LEGAL_CONTACT_EMAIL = 'christiancalvert@live.ca';
